<template>
  <div>
    <c-table
      title="화학물질 변경내역 목록"
      :columns="columns"
      :data="displayRows"
      :gridHeight="gridHeight"
      :usePaging="false"
      :customTrClass="
        (_props) =>
          (_props.row.casNo && !_props.row.mdmChemId) || _props.row.newChemFlag === 'Y'
            ? 'bg-orange-1'
            : ''
      "
    >
      <template v-slot:table-chip>
        <span
          v-if="newChemRows.length > 0"
          class="q-ml-lg text-deep-purple"
          style="font-size: 0.94em"
        >
          ✔️ 기존 화학물질에 없는 건은 오렌지색으로 표시되며, 규제 적용 시 화학물질에 신규로
          등록됩니다. (총
          {{ newChemRows.length }} 건)
          <q-chip
            outline
            square
            clickable
            size="12px"
            color="orange"
            class="q-ml-sm"
            :label="newChemOnly ? '전체보기' : '신규 물질만 보기'"
            @click="newChemOnly = !newChemOnly"
          />
        </span>
      </template>
      <template v-slot:table-button>
        <q-btn-group outline>
          <c-btn
            v-if="editable && param.statusCd === 'CEUS000005'"
            label="삭제"
            icon="delete_forever"
            @btnClicked="deleteUpload"
          />
          <c-btn
            v-if="editable && param.statusCd === 'CEUS000005'"
            label="규제 적용"
            icon="check"
            @btnClicked="applyRegulation"
          />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'impactMaterials'">
          <template v-for="(material, index) in props.row.impactMaterials || []">
            <span
              :key="material.mdmChemMaterialId"
              class="tableinnerBtn tableinnerBtn-left cursor-pointer text-blue-6"
              @click="openMaterial(material.mdmChemMaterialId)"
              >{{ material.mdmChemMaterialName }}</span
            ><span
              v-if="index < (props.row.impactMaterials || []).length - 1"
              :key="'sep' + material.mdmChemMaterialId"
              class="q-mr-xs"
              >,&nbsp;</span
            >
          </template>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from '@/js/transactionConfig';
import selectConfig from '@/js/selectConfig';

// 위험물안전관리법(D140)
const DANGEROUS_ITEM_BILL_CD = 'D140';
const baseColumns = [
  {
    name: 'chemNmKr',
    field: 'chemNmKr',
    label: '화학물질(국문)',
    align: 'left',
    style: 'width:160px',
    sortable: true,
  },
  {
    name: 'chemNmEn',
    field: 'chemNmEn',
    label: '화학물질(영문)',
    align: 'left',
    style: 'width:160px',
    sortable: true,
  },
  {
    name: 'casNo',
    field: 'casNo',
    label: 'CAS No.',
    align: 'left',
    style: 'width:110px',
    sortable: true,
  },
  {
    name: 'regulationBillName',
    field: 'regulationBillName',
    label: '법규',
    align: 'left',
    style: 'width:160px',
    sortable: true,
  },
  {
    name: 'regulatedItemName',
    field: 'regulatedItemName',
    label: '규제',
    align: 'left',
    style: 'width:160px',
    sortable: true,
  },
  {
    name: 'flagName',
    field: 'flagName',
    label: '변경유형',
    align: 'center',
    style: 'width:80px',
    sortable: true,
  },
  {
    name: 'changeContents',
    field: 'changeContents',
    label: '변경내용',
    align: 'left',
    style: 'width:200px',
    type: 'html',
    sortable: false,
  },
  {
    name: 'impactMaterials',
    field: 'impactMaterials',
    label: '영향품목',
    align: 'left',
    type: 'custom',
    style: 'width:220px',
    sortable: false,
  },
];

export default {
  name: 'chemUpdateDbUploadCheck',
  props: {
    param: {
      type: Object,
      default: () => ({
        mdmMaterialRegulatoryInfoExcelUploadId: '',
        stepCd: 'CUED000005',
        statusCd: 'CEUS000005',
        searchProcess: { flag: '', isSearch: false },
      }),
    },
    height: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      editable: true,
      rows: [],
      newChemOnly: false,
      changesUrl: '',
      applyUrl: '',
      deleteUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    newChemRows() {
      return this.rows.filter((item) => (item.casNo && !item.mdmChemId) || item.newChemFlag === 'Y');
    },
    displayRows() {
      return this.newChemOnly ? this.newChemRows : this.rows;
    },
    columns() {
      if (!this.rows.some((row) => row.regulationBillCd === DANGEROUS_ITEM_BILL_CD)) return baseColumns;
      const result = [...baseColumns];
      result.splice(5, 0, {
        name: 'dangerItemName',
        field: 'dangerItemName',
        label: '위안법 세부분류',
        align: 'left',
        style: 'width:160px',
        sortable: true,
      });
      return result;
    },
    // CStep 스텝 높이에 맞춰 변경내역 목록을 팝업 하단까지 채움
    gridHeight() {
      return this.height ? String(Number(String(this.height).replace('px', '')) - 20) + 'px' : '750px';
    },
  },
  watch: {
    'param.searchProcess.flag'() {
      this.getChanges();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.changesUrl = selectConfig.chm.regul.updateData.excelUpload.changes.url;
      this.applyUrl = transactionConfig.chm.regul.updateData.excelUpload.apply.url;
      this.deleteUrl = transactionConfig.chm.regul.updateData.excelUpload.delete.url;
      // code setting
      // list setting
      this.getChanges();
    },
    /**
     * 엑셀 업로드 변경내역 조회
     */
    getChanges() {
      if (!this.param.mdmMaterialRegulatoryInfoExcelUploadId) return;

      this.$http.url = this.$format(this.changesUrl, this.param.mdmMaterialRegulatoryInfoExcelUploadId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.rows = (_result.data || []).map((row) => Object.assign({}, row, {
          flagName: row.flag === 'I' ? '신규' : row.flag === 'D' ? '삭제' : '변경',
        }));
      });
    },
    /**
     * 규제 적용
     */
    applyRegulation() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '규제를 적용하시겠습니까?',
        type: 'info',
        confirmCallback: () => {
          this.$http.url = this.$format(this.applyUrl, this.param.mdmMaterialRegulatoryInfoExcelUploadId);
          this.$http.type = 'POST';
          this.$http.param = {
            regUserId: this.$store.getters.user.userId,
            chgUserId: this.$store.getters.user.userId,
          };
          this.$http.request(() => {
            this.$emit('emitStep', {
              name: 'currentStep',
              param: {
                mdmMaterialRegulatoryInfoExcelUploadId: this.param.mdmMaterialRegulatoryInfoExcelUploadId,
                statusCd: 'CEUS000010',
              },
            });
            window.getApp.$emit('ALERT', {
              title: '안내',
              message: '규제를 적용하였습니다.',
              type: 'success',
            });
          });
        },
        cancelCallback: () => {},
      });
    },
    /**
     * 엑셀 업로드 삭제(적용 전)
     */
    deleteUpload() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '업로드 데이터를 삭제하시겠습니까?',
        type: 'warning',
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.param.mdmMaterialRegulatoryInfoExcelUploadId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('ALERT', {
              title: '안내',
              message: '삭제하였습니다.',
              type: 'success',
            });
            // 팝업 닫기(목록 재조회는 closeCallback에서 수행)
            this.$emit('emitStep', {
              name: 'closePopup',
              param: null,
            });
          });
        },
        cancelCallback: () => {},
      });
    },
    /**
     * 영향 품목 상세 팝업
     */
    openMaterial(id) {
      this.popupOptions.title = '품명 상세';
      this.popupOptions.param = { mdmChemMaterialId: id, tabName: 'chemMsds' };
      this.popupOptions.target = () => import(`${'../chemDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
